if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button.share-button__button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          exportButton: this.querySelector('button.export-button__button'),
          exportGuidance: this.querySelector('div.export-guidance'),
          refreshButton: this.querySelector('button.export-guidance__button')
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
        if (this.elements.exportButton) {
          this.elements.exportButton.addEventListener('click', this.generateInfoBoard.bind(this))
        }
        if (this.elements.refreshButton){
          this.elements.refreshButton.addEventListener('click', ()=>{location.reload()})
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }

      generateInfoBoard() {
        document.querySelector('div.product__title').style.paddingTop = "0";
        
        const productTitles = document.querySelectorAll('div.product__title > h1, div.product__model > h2');
        const modelText = document.querySelector('div.product__model > span').innerText;
        productTitles.forEach(title => {
          title.style.fontFamily = 'Nunito Sans ExtraBold';
          title.style.width = '450px';
          if (title.tagName === 'H2') {
              title.style.color = '#008CFF';
              title.style.fontSize = '18px';
              title.textContent = title.textContent.trim().slice(0, -4);
              title.textContent = modelText + ': ' + title.textContent;
          }
          if (title.tagName === 'H1') {
              title.style.fontSize = '23px';
          }
        });

        const productDescriptions = document.querySelectorAll('div.product__description.cudy');
        productDescriptions.forEach(description => {
          description.style.backgroundColor = '#F2F2F2';
          description.style.width = '450px';
          description.style.marginTop = '6px';
          description.style.marginBottom = '0px';

          const paragraphs = description.querySelectorAll('p, li');
          paragraphs.forEach(paragraph => {
              paragraph.style.fontSize = '16px';
              paragraph.style.color = 'black';
          });

          const superscripts = description.querySelectorAll('sup');
          superscripts.forEach(sup => sup.remove());
        });

        const productInfo = document.querySelector('product-info');
        productInfo.classList = "product-info-border";
        productInfo.style.border = '1px solid #cccccc';
        productInfo.style.padding = '30px';
        productInfo.style.width = '510px';
        productInfo.style.height = '765px';
        productInfo.style.display = 'block';
        productInfo.style.zoom = '1.113';
        productInfo.querySelector('.product__title').style.textAlign = "left"
        const productNoMedia = document.querySelector(".product--no-media")
        if(productNoMedia){
          productNoMedia.classList.remove('product--no-media')
        }

        const semiphereLogoWrapper = document.createElement('div');
        semiphereLogoWrapper.style.transform = 'translate(0px, -49px)';
        semiphereLogoWrapper.style.height = '60px';

        const semiphereLogo = document.createElement('img');
        semiphereLogo.src = 'https://cdn.shopify.com/s/files/1/0673/4748/0820/files/hemisphere_Cudy_Logo_with_blood_line_RGB.svg?v=1741758162';
        semiphereLogo.style.width = '124px';

        semiphereLogoWrapper.appendChild(semiphereLogo);
        productInfo.insertBefore(semiphereLogoWrapper, productInfo.firstChild);

        const shareButton = document.querySelector("share-button");
        shareButton.querySelector("button.share-button__button").remove();
        shareButton.querySelector("button.export-button__button").remove();
        shareButton.querySelector("details").remove();
        const variantSelects = document.querySelector("variant-selects");
        if (variantSelects) {
          variantSelects.remove();
        }
        document.querySelector('footer').remove();
        document.querySelectorAll('.product__compatibility').forEach(el => el.remove());
        document.querySelector('.grid__item.product__media-wrapper').remove();
        document.querySelector('header').remove();

        const sections = document.querySelectorAll('section');
        sections.forEach(section => {
          if (!section.querySelector('product-info')) {
            section.remove();
          }
        });

        const shopifySections = document.querySelectorAll(".shopify-section")
        shopifySections.forEach(section => {
          if (!section.querySelector('product-info')) {
            section.remove();
          }
        });

        function addCssRule(selector, rules) {
          const style = document.createElement('style');
          style.textContent = `${selector} { ${rules} }`;
          document.head.appendChild(style);
        }
        
        addCssRule('li', 'padding-bottom: 10px;');
        addCssRule('li:last-of-type', 'padding-bottom: 0;');
        this.elements.exportGuidance.classList.remove('hidden');

        document.querySelector("product-info").parentNode.insertBefore(document.querySelector("share-button"), document.querySelector("product-info").nextSibling);

        if(window.innerWidth > 1200){
          document.querySelector("share-button").style.margin = "3rem"
          document.querySelector(".product__info-wrapper").style.minWidth = "1080px"
          document.querySelector(".product__info-wrapper").style.display = "flex"
        }
      }
    }
  );
}
